import React from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";

export default function ServersCreateBreadcrumb() {
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  const navigateToServers = () => {
    navigate({
      pathname: "/edge-management/servers",
    });
  };

  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item
        onClick={() => {
          navigateToServers();
        }}
        className="generalStyles__breadcrumbItemInactive"
      >
        {t("header.servers")}
      </Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("edgeManagement.servers.createNewServer")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}
